<template>
  <div>
    <input
      :id="value"
      class="x-radio-button-large"
      type="radio"
      :checked="checked"
      :name="name"
      :value="value"
      :disabled="disabled"
      @input="input"
    >

    <label
      :class="['x-radio-button-large-label', { 'x-radio-button-large-disabled': disabled }]"
      :for="value"
    >
      <div
        v-if="checked"
        class="tick-filled"
      >
        <ic-tick-filled />
      </div>

      <div class="wizard-radio-content">
        <div class="wizard-radio-content-text-icon">
          <slot name="icon" />
        </div>
        <div>
          {{ label }}
        </div>
      </div>
    </label>
  </div>
</template>

<script>
  import icTickFilled from '@/svg/ic-tick-filled'

  export default {
    name: 'XRadioButtonLarge',

    components: {
      icTickFilled
    },

    props: {
      name: {
        type: String,
        required: true
      },
      value: {
        type: String,
        required: true
      },
      checked: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: true
      }
    },

    methods: {
      input (e) {
        this.$emit('input', e.target.value)
      }
    }
  }
</script>


<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .x-radio-button-large-label {
    display: flex;
    height: 16.6rem;
    width: 100%;
    border-radius: 0.4rem;
    background-color: #F8F8F8;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    position: relative;
    cursor: pointer;
  }

  .x-radio-button-large {
    display: none;
  }

  .x-radio-button-large[type="radio"]:checked+label {
    height: 16.6rem;
    width: 100%;
    border: 0.3rem solid map_get($palette-primary, main);
    border-radius: 0.4rem;
    background-color: rgba(map_get($palette-primary, main), 0.1);
    color: map_get($palette-primary, main);
  }

  .x-radio-button-large-disabled {
    opacity: 0.4;
    cursor: default;
  }

  .tick-filled {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(50%) translateY(-50%);
  }

  .wizard-radio-content {
    text-align: center;

    .wizard-radio-content-text-icon {
      margin-bottom: $space-small;
    }
  }
</style>